import { useDisclosure } from '@mantine/hooks';
import { useSubmitVault } from '@modules/vault/hooks/mutations/submitVault';
import { useGetVaultStorage } from '@modules/vault/hooks/queries/useGetVaultStorage';
import { getInitialValues } from '@modules/opportunities/presentation/pages/CaseCreation/views/FillBankForms/VaultForm/utils';
import { VaultFormValues } from '@modules/opportunities/presentation/pages/CaseCreation/views/FillBankForms/VaultForm/form-context';

export const useVaultReview = (opportunityId: string, clientId: string) => {
  const { data: vaultStorageData, isClientNotLoggedIn } = useGetVaultStorage(opportunityId);
  const [isOpened, { close, open }] = useDisclosure(false);
  const isVaultStorageDraft = !isClientNotLoggedIn && vaultStorageData?.vault_status === 'draft';

  const {
    mutateAsync: submitVault,
    isPending: isSubmitVaultLoading,
    error: vaultError,
  } = useSubmitVault(opportunityId, clientId);
  const handleVaultReview = async () => {
    if (isVaultStorageDraft) {
      const data = getInitialValues(
        vaultStorageData.vault_data_json.applicants
      ) as VaultFormValues<'AE'>;
      try {
        await submitVault(data);
        return false;
      } catch {
        open();
        return true;
      }
    }
    return false;
  };

  return {
    isOpened,
    handleVaultReview,
    close,
    isSubmitVaultLoading,
    vaultError,
  };
};
